import { defineComponent as k, ref as p, nextTick as w, onBeforeUnmount as h, onMounted as v, watch as C, toRefs as M, openBlock as n, createElementBlock as o, normalizeStyle as f, Fragment as d, renderList as c, unref as W, renderSlot as _, createTextVNode as x, toDisplayString as B } from "vue";
import { useMasonryWall as S } from "@yeger/vue-masonry-wall-core";
const $ = ["data-index"], b = /* @__PURE__ */ k({
  __name: "masonry-wall",
  props: {
    columnWidth: { default: 400 },
    items: {},
    gap: { default: 0 },
    rtl: { type: Boolean, default: !1 },
    ssrColumns: { default: 0 },
    scrollContainer: { default: null },
    minColumns: { default: 1 },
    maxColumns: { default: void 0 },
    keyMapper: { type: Function, default: (t, s, i, r) => r }
  },
  emits: ["redraw", "redrawSkip"],
  setup(t, { emit: s }) {
    const i = t, r = p([]), u = p(), { getColumnWidthTarget: y } = S({
      columns: r,
      emit: s,
      nextTick: w,
      onBeforeUnmount: h,
      onMounted: v,
      vue: 3,
      wall: u,
      watch: C,
      ...M(i)
    });
    return (e, T) => (n(), o("div", {
      ref_key: "wall",
      ref: u,
      class: "masonry-wall",
      style: f({ display: "flex", gap: `${e.gap}px` })
    }, [
      (n(!0), o(d, null, c(r.value, (g, l) => (n(), o("div", {
        key: l,
        class: "masonry-column",
        "data-index": l,
        style: f({
          display: "flex",
          "flex-basis": `${W(y)(l)}px`,
          "flex-direction": "column",
          "flex-grow": 1,
          gap: `${e.gap}px`,
          height: [
            "-webkit-max-content",
            "-moz-max-content",
            "max-content"
          ],
          "min-width": 0
        })
      }, [
        (n(!0), o(d, null, c(g, (a, m) => (n(), o("div", {
          key: e.keyMapper(e.items[a], l, m, a),
          class: "masonry-item"
        }, [
          _(e.$slots, "default", {
            item: e.items[a],
            column: l,
            row: m,
            index: a
          }, () => [
            x(B(e.items[a]), 1)
          ])
        ]))), 128))
      ], 12, $))), 128))
    ], 4));
  }
}), D = /* @__PURE__ */ (() => {
  const t = b;
  return t.install = (s) => {
    s.component("MasonryWall", t);
  }, t;
})();
export {
  D as default
};
